// Phone product gallery (owner, 2026-10-20): the "2/13" chip on the photo becomes the card's dot pill
// (assets/sa-card-video.js): the photo you are on is the long white bar and the video slide is a ▶, so the shopper
// sees where the video is before swiping. It stays where the chip was, bottom right, and as small as the card pill:
// with more than 5 media only 5 places show and the row slides along, the outer dots smaller when more lie beyond.
// - Phones only (under 750px, the width where assets/sa-pdp-v2.css puts the chip on the photo).
// - "2 of 13" stays in the chip for screen readers; the dots are hidden from them.
// - Changing the variant can reorder the slides (product-info.js updateMedia), so the dots follow the list.
// - Without this script the chip keeps its numbers.
(() => {
  if (window.saGalleryPill) return;
  const WINDOW = 5;
  // Must match .sa-gpill sizes in assets/sa-pdp-v2.css (px).
  const SIZE = {dot: 6, edge: 4, active: 16, video: 8, gap: 5};
  const phone = window.matchMedia('(max-width: 749px)');

  // Which dots show for slide `index` of `total`: the first visible place, so the current one sits in the middle
  // once there are more than WINDOW, and which ends are cut (their dot is drawn smaller).
  function windowFor(index, total) {
    const shown = Math.min(WINDOW, total);
    const start = total <= WINDOW ? 0 : Math.max(0, Math.min(total - WINDOW, index - Math.floor(WINDOW / 2)));
    return {start, shown, cutLeft: start > 0, cutRight: start + shown < total};
  }

  // Width of each dot in its final state, so the row is placed without reading sizes mid-transition.
  function widths(kinds, index, view) {
    return kinds.map((video, at) => {
      if (video) return SIZE.video;
      if (at === index) return SIZE.active;
      if ((view.cutLeft && at === view.start) || (view.cutRight && at === view.start + view.shown - 1)) return SIZE.edge;
      return SIZE.dot;
    });
  }

  function attach(slider) {
    const counter = slider.querySelector('.slider-counter');
    const list = slider.querySelector('.product__media-list');
    if (!counter || !list || counter.querySelector('.sa-gpill')) return;
    const pill = document.createElement('span');
    pill.className = 'sa-gpill';
    pill.setAttribute('aria-hidden', 'true');
    pill.innerHTML = '<span class="sa-gpill__win"><span class="sa-gpill__track"></span></span>';
    const win = pill.firstChild;
    const track = win.firstChild;
    counter.append(pill);
    let kinds = [];
    let dots = [];

    const slides = () => [...list.querySelectorAll('[id^="Slide-"]')].filter(slide => slide.clientWidth > 0);
    const build = () => {
      kinds = slides().map(slide => !!slide.querySelector('.media-type-video'));
      track.innerHTML = kinds.map(video => `<i class="sa-gpill__dot${video ? ' sa-gpill__dot--video' : ''}"></i>`).join('');
      dots = [...track.children];
      counter.classList.toggle('sa-gpill-on', kinds.length > 1);
      update();
    };
    const update = () => {
      if (!kinds.length) return;
      const step = list.firstElementChild?.clientWidth || list.clientWidth || 1;
      const index = Math.max(0, Math.min(kinds.length - 1, Math.round(list.scrollLeft / step)));
      const view = windowFor(index, kinds.length);
      const sizes = widths(kinds, index, view);
      dots.forEach((dot, at) => {
        dot.classList.toggle('is-active', at === index);
        dot.classList.toggle('is-edge', sizes[at] === SIZE.edge);
      });
      const left = sizes.slice(0, view.start).reduce((sum, width) => sum + width + SIZE.gap, 0);
      const visible = sizes.slice(view.start, view.start + view.shown).reduce((sum, width) => sum + width, 0) + SIZE.gap * (view.shown - 1);
      track.style.transform = `translateX(${-left}px)`;
      win.style.width = `${visible}px`;
    };

    list.addEventListener('scroll', update, {passive: true});
    slider.addEventListener('slideChanged', update);
    new MutationObserver(build).observe(list, {childList: true});
    build();
  }

  function run() {
    if (!phone.matches) return;
    document.querySelectorAll('.sa-pdp-v2 media-gallery slider-component').forEach(attach);
  }

  window.saGalleryPill = {windowFor, widths, run};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  phone.addEventListener?.('change', run);
})();
